<style scoped>
/*.footer{height:60px;line-height:60px;text-align: center;background-color:rgb(250,250,250)}*/
.footer{height:60px;line-height:60px;text-align: center;background-color:rgb(235, 235, 235)}
</style>
<template>
  <div class="footer">
    技术支持：律蛙智能
  </div>
</template>
<script>
  export default {
    name: "sysFooter"
  }
</script>